import { RootErrorAlert } from "@nimble/react-requests/components/shared/root-error-alert";
import { useFormState } from "react-hook-form";

const FormRootError = () => {
  const { errors } = useFormState();
  const rootError = errors.root;

  if (!rootError) {
    return null;
  }

  return <RootErrorAlert message={rootError.message} />;
};

export default FormRootError;
